/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: inde.ts
 * Class: inde.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { AxiosInstance } from 'axios';

export interface RootState {
  version: string;
  $http: AxiosInstance;
}

/**
 * useful for for than one action and multiple states
 */
export enum MutationRequestStatus {
  LOADING = 0,
  SUCCESS = 1,
  ERROR = 2
}

export interface MutationRequestError<T> {
  code: number;
  message: string;
  data: T;
}

export interface MutationRequestState<T, S> {
  data: T;
  error: MutationRequestError<S>;
  status: MutationRequestStatus;
}
